export default import.meta.ROLLUP_FILE_URL_aLISaAY6NSiJFT$6GdtrfA;